<script>
  import Icon from '#lib/Icon.svelte';
  import { unique_classes } from '#lib/util.js';

  let {
    /** @type {string} optional name of the icon to be displayed */
    icon,
    /** @type {string} additional CSS classes to be attached to the label (use sparingly) */
    class: css_class,
    /** @type {string} text content to be displayed */
    children,
    /** @type {'start'|'top'|'bottom'|'end'} */
    placement = 'top',
  } = $props();
</script>

<div
  class={unique_classes(
    'text-label',
    icon && 'icon',
    placement,
    css_class
  )}
>
  {#if children}
    <span class='text-control leading-trim'>
      {@render children()}
    </span>
  {/if}
  {#if icon}
    <Icon name={icon} />
  {/if}
</div>

<style lang="postcss">
  /* Styles for canvas variant, used on editable pages */
  .text-label {
    --icon-color1: var(--editing);
    --color-background: var(--editing);
    --icon-color2: var(--editing-200);
    --text-label-padding: var(--size-3);
    --text-label-offset: var(--size-2);
    pointer-events: none;
    user-select: none;
    display: none;
    align-items: center;
    * {
      color: var(--editing);
    }
    text-align: left;
    border-radius: var(--round);
    padding: var(--text-label-padding);
    width: auto;
    height: auto;
    &:has(span:not(:empty)) {
      padding-inline: calc(2 * var(--text-label-padding));
      &.top {
        gap: var(--size-2);
      }
    }
    &:not(:has(span)){
      aspect-ratio: 1;
    }
    span:empty {
      display: none;
    }
    position: absolute;
    z-index: 1;
    text-overflow: ellipsis;
    white-space: nowrap;

    /* Add a blur so labels of neighbouring elements are less visible */
    backdrop-filter: blur(10px);
    /* Add a box-shadow for a gradual overlay of label and neighbouring overlapping labels */
    background-color: oklch(1 0 0 / 0.9);
    border: 1px solid var(--editing);
    &.top {
      left: 0;
      /* box-shadow: 
        var(--color-background) calc(-1 * var(--text-label-offset)) 0 calc(var(--text-label-offset) / 2),
        var(--color-background) var(--text-label-offset) 0 calc(var(--text-label-offset) / 2); */
      transform: translateX(calc(-100% - 0.5 * var(--text-label-offset))) translateY(-50%);
    }
    &.start {
      left: 0;
      transform: translateX(calc(-100% - 0.5 * var(--text-label-offset))) translateY(calc(-50% + 0.5em));
      &:has(:not(span)){
        aspect-ratio: 1;
      }
    }
    &.bottom {
      left: 0;
      /* box-shadow: 
        var(--color-background) calc(-1 * var(--text-label-offset)) 0 calc(var(--text-label-offset) / 2),
        var(--color-background) var(--text-label-offset) 0 calc(var(--text-label-offset) / 2);
      transform: translateX(calc(-1.5 * var(--text-label-padding))) translateY(calc(100% + var(--text-label-offset))); */
    }
    &.end {
      right: 0;
      transform: translateX(calc(3 * var(--text-label-padding))) translateY(calc(-50% + 0.5em));
      &:has(:not(span)){
        aspect-ratio: 1;
      }
    }
  }

  :global(*:has(> .text-label + [contenteditable="true"]:focus-visible) > .text-label) {
    color: var(--editing);
    display: flex;
  }

  /* :global(*:has(> .text-label + [contenteditable="true"]:empty) > .text-label) {
    display: flex;
  } */

  :global(*:has(> .text-label + [contenteditable="true"]:focus-visible)) {
    z-index: 2;
  }
</style>
